import { render, staticRenderFns } from "./NewTasks.vue?vue&type=template&id=1ddca038&scoped=true"
import script from "./NewTasks.vue?vue&type=script&lang=js"
export * from "./NewTasks.vue?vue&type=script&lang=js"
import style0 from "./NewTasks.vue?vue&type=style&index=0&id=1ddca038&prod&lang=less&scoped=true"
import style1 from "./NewTasks.vue?vue&type=style&index=1&id=1ddca038&prod&lang=less&scoped=true"
import style2 from "./NewTasks.vue?vue&type=style&index=2&id=1ddca038&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddca038",
  null
  
)

export default component.exports